import React, { Component, Fragment } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Button } from 'reactstrap';
import {themeSaveButton} from '../Utils/EsaedroTheme';


interface IEsaedroPDFProps {
    file: string
    filename: string
  }
export default class EsaedroPDF extends Component<IEsaedroPDFProps> {


  componentDidMount() {
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }

  /*onDocumentLoadSuccess = ( numPages: any ) => {
    this.setState({ numPages });
  }*/

  render() {
    const { file, filename } = this.props;

    return (  
        <Fragment>
            <a href={file} target="_blank" rel="noopener noreferrer" download={filename+".pdf"} title="Download PDF">
            <Button className={themeSaveButton()} >
                <i className="fa fa-download"/>  Download PDF
            </Button>
            </a>
            <Document file={file}>
                <Page pageNumber={1}/>
            </Document>
        </Fragment>
    );
  }

  // Alcune opzioni da tenere buone
  /*render() {
    const { file, numPages } = this.state;

    return (
      <div className="Example">
        <header>
          <h1>react-pdf sample page</h1>
        </header>
        <div className="Example__container">
          <div className="Example__container__document">
            <Document
              file={file}
              onLoadSuccess={this.onDocumentLoadSuccess}
              options={options}
            >
              {
                Array.from(
                  new Array(numPages),
                  (el, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                    />
                  ),
                )
              }
            </Document>
          </div>
        </div>
      </div>
    );
  }*/
}